import { action } from "@storybook/addon-actions";
import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import Toggle from "./Toggle";

type Story = GenericStory<React.ComponentProps<typeof Toggle>>;

const commonArgs: React.ComponentProps<typeof Toggle> = {
    checked: false,
    onChange: action("onChange"),
    trackName: "Stories.Toggle.TrackEvent",
    size: "sm",
    disabled: false
};

export default {
    title: "common/Toggle",
    component: Toggle,
    args: commonArgs,
    argTypes: { size: { control: "radio", options: ["sm", "md"] } }
} as ComponentMeta<typeof Toggle>;

const Template: Story = ({ checked: checkedProp, onChange, ...args }) => {
    const [checked, setChecked] = React.useState(checkedProp);

    React.useEffect(() => {
        setChecked(checkedProp);
    }, [checkedProp]);

    const handleChange = (value: boolean) => {
        setChecked(value);
        onChange(value);
    };

    return <Toggle checked={checked} onChange={handleChange} {...args} />;
};

export const Default = Template.bind({});

export const WithLabel = Template.bind({});
WithLabel.args = {
    label: "Toggle Label",
    helperText: "Toggle helper text"
};
